import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ApiCoverageDetail } from '@bhtp-client-api/base';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, ValidatorFn } from '@angular/forms';
import { OptionalCoverageComponent, IncludedCoverageComponent, CoverageViewConfig } from '@bhtp-client-web/component';
import { EditSectionComponent } from './../edit-section.component';
import { departureDateValidator, returnDateValidator, CoverageFormService } from '@bhtp-client-web/component';
import { Coverage, CoverageContainer, FeatureService } from './../../shared';
import { Observable } from 'rxjs';
import { PolicyFlightOverride } from '@bhtp-client-web/component';

@Component({
    selector: 'edit-coverage-list',
    template: require('./edit-coverage-list.component.html')
})
export class EditCoverageListComponent extends EditSectionComponent<CoverageContainer> implements OnInit, OnChanges {
    @Input() public includedCoverages: Array<Coverage>;
    @Input() public optionalCoverages: Array<Coverage>;

    @Input() public carRentalCompany: string;
    @Input() public dropoffDate: string;
    @Input() public pickupDate: string;

    @Input() public tripDepartureDate: string;
    @Input() public tripReturnDate: string;

    @Input() public quoting: boolean;

    @Input() public flightReminderPolicy: PolicyFlightOverride;
    @Output() public scrollToFlightsEmitter: EventEmitter<string> = new EventEmitter<string>();

    private buttonText: string = `ADD CUSTOMER'S FLIGHTS`;
    private message: string = `If flight information is provided prior to the departure date, flights can be tracked and claims can be automatically created. Insuring more than 4 flights will incur additional premium charges.`;
    private messageHeading: string = `Don't forget to add flights!`;
    private formConfiguration: CoverageViewConfig;

    private optionalCoveragesFormArray: FormArray;
    private writtingValues: boolean = false;
    private blockedProvidersBaseUrl: string;

    public get showFlightReminder(): boolean {
        if (this.flightReminderPolicy && this.flightReminderPolicy.futureFlightsExpected && this.flightReminderPolicy.flightCount === 0) {
            return true;
        }

        return false;
    }

    constructor(private fb: FormBuilder, private coverageFormService: CoverageFormService, private features: FeatureService) {
        super();
        this.optionalCoveragesFormArray = new FormArray([]);
        this.blockedProvidersBaseUrl = this.features.getConsumerDomain();
    }

    public ngOnInit(): void {

    }

    public ngOnChanges(changes: SimpleChanges): void {
        // changes have been made to optional coverages or their data
        if ((changes['optionalCoverages'] || changes['carRentalCompany'] || changes['tripDepartureDate'] || changes['tripReturnDate']) && this.optionalCoveragesFormArray && this.optionalCoverages && !this.writtingValues) {
            this.buildCoverageForm();
        }
    }

    public canContinue(isQuickQuote: boolean = false): Observable<boolean> {
        return Observable.create((observer) => {
            observer.next(this.optionalCoveragesFormArray.valid);
            observer.complete();
        });
    }

    public writeValues(target: CoverageContainer): void {
        this.writtingValues = true;
        // Let's reconcile the coverage information
        for (let i: number = 0; i <= this.optionalCoveragesFormArray.length - 1; i++) {
            let index: number = this.coverageFormService.findWithAttr(target.optionalCoverages, 'ratingId', this.optionalCoverages[i].ratingId);
            if (index !== -1) {
                target.optionalCoverages[index] = (Coverage.combineOptionalCoverageFormGroupAndEditCoverageToEditCoverage(this.optionalCoverages[i], <FormGroup>this.optionalCoveragesFormArray.controls[i]));
                // Ok lets see if they have rental dates and rental company
                if (Coverage.hasDates(this.optionalCoverages[i])) {
                    target.rentalInformation = (Coverage.combineOptionalCoverageFormGroupAndCoverageToRentalInformation(this.optionalCoverages[i], <FormGroup>this.optionalCoveragesFormArray.controls[i]));
                }
            }
        }
        this.writtingValues = false;
    }

    private buildCoverageForm(): void {
        this.formConfiguration = new CoverageViewConfig();
        this.formConfiguration.optionalCoverages = this.optionalCoverages;
        this.formConfiguration.carRentalCompany = this.carRentalCompany;
        this.formConfiguration.dropoffDate = this.dropoffDate;
        this.formConfiguration.pickupDate = this.pickupDate;
        this.formConfiguration.tripDepartureDate = this.tripDepartureDate;
        this.formConfiguration.tripReturnDate = this.tripReturnDate;

        let tempControls: FormArray = this.coverageFormService.buildCoverageForm(this.formConfiguration, true);

        tempControls.valueChanges.debounceTime(500).subscribe((changes) => {
            let coverageContainer: CoverageContainer = new CoverageContainer();
            coverageContainer.optionalCoverages = new Array<Coverage>();
            for (let i: number = 0; i <= this.optionalCoveragesFormArray.length - 1; i++) {
                coverageContainer.optionalCoverages.push(Coverage.combineOptionalCoverageFormGroupAndEditCoverageToEditCoverage(this.optionalCoverages[i], <FormGroup>this.optionalCoveragesFormArray.controls[i]));
                // Ok lets see if they have rental dates and rental company
                if (Coverage.hasDates(this.optionalCoverages[i])) {
                    coverageContainer.rentalInformation = (Coverage.combineOptionalCoverageFormGroupAndCoverageToRentalInformation(this.optionalCoverages[i], <FormGroup>this.optionalCoveragesFormArray.controls[i]));
                }
            }
            this.valueChanges.emit(coverageContainer);
        });

        this.optionalCoveragesFormArray = tempControls;
    }

    private scrollToFlights(policyNumber: string): void {
        this.scrollToFlightsEmitter.emit(policyNumber);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/coverages/edit-coverage-list.component.ts